export default __webpack_public_path__ + "static/media/Operations Research.c88b85d9.pdf";